import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../utils/api';

const POLL_INTERVAL_MS = 60_000;

// Bundled poll for notifications unread count + task counts + active announcements.
// React Query dedupes — multiple consumers share one network call per cycle.
export function useBadges() {
  return useQuery({
    queryKey: ['badges'],
    queryFn: async () => {
      const response = await apiGet('/badges');
      if (!response.ok) throw new Error(`Failed to load badges (${response.status})`);
      return response.json();
    },
    refetchInterval: POLL_INTERVAL_MS,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
